import { DomainError } from '@dma/shared';

export class InvalidProjectError extends DomainError {
  constructor(reason: string) {
    super('INVALID_PROJECT', `Project is invalid: ${reason}`);
    this.name = 'InvalidProjectError';
    Object.setPrototypeOf(this, InvalidProjectError.prototype);
  }
}
